/*For bootstrap integration*/
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import $ from 'jquery';
// import jszip from 'jszip';
import Popper from 'popper.js';
/*For notifications*/
import 'react-toastify/dist/ReactToastify.css';

// Kendo Styles
import '@progress/kendo-theme-default/dist/all.css';
// Kendo js (to can use Spreadsheet wrapper)
import "@progress/kendo-ui/js/kendo.all.min.js";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

/*For internazionalization we use i18next library*/
import {I18nextProvider} from "react-i18next"
import i18next from './assets/translations/initI18n'

/*For routing we use React Router library*/
import { BrowserRouter as Router } from 'react-router-dom'

// * Test Configuration for Backend API Base URL (see ./services/api.js)
if (!process.env.REACT_APP_RAP_API_BASE_URL) {
    console.error("Configuration error: Undefined Backend API url. Missing env variable. Falling back to default. Possible cause: missing .env file.");
} else {
    console.info("Backend API enpoint configured.") // ("API URL:" + process.env.REACT_APP_RAP_API_BASE_URL)
}

// * Test Configuration for AMS API URL (see ./services/api.js)
if (!process.env.REACT_APP_RAP_AMS_BASE_URL) {
    console.error("Configuration error: Undefined AMS API url. Missing env variable. Falling back to default. Possible cause: missing .env file.");
} else {
    console.info("AMS API endpoint configured.") // ("AMS API URL:" + process.env.REACT_APP_RAP_AMS_BASE_URL)
}

// * Render DOM
ReactDOM.render(
    <I18nextProvider i18n={i18next}>
        <Router basename="/RAP" >
            <App />
        </Router>
    </I18nextProvider>, 
    document.getElementById("root")
);
